import React, { ComponentProps, PropsWithChildren } from "react";

import "./BottomSheet.scss";
import Overlay from "../Overlay/Overlay";

interface BottomSheetProps extends ComponentProps<"div"> {
  isOpen: boolean;
}

function BottomSheet({
  children,
  isOpen,
  className = "",
  ...restProps
}: PropsWithChildren<BottomSheetProps>) {
  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className={`custom-buttom-sheet MobileOnly ${
          isOpen ? "" : "d-none"
        } ${className}`}
        {...restProps}
      >
        {children}
      </div>
      {isOpen && <Overlay />}
    </>
  );
}

export default BottomSheet;
